import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fa897c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "exhibition-block-content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt" }, null, -1))
const _hoisted_3 = { class: "exhibition-block-content-venue" }
const _hoisted_4 = { class: "is-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1))
const _hoisted_6 = { class: "exhibition-block-content-date" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-text-white mx-3 mt-1" }, "-", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt" }, null, -1))
const _hoisted_10 = { class: "exhibition-block-content-date" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconText = _resolveComponent("IconText")!
  const _component_EsDate = _resolveComponent("EsDate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconText, { dark: true }, {
        icon: _withCtx(() => [
          _hoisted_2
        ]),
        text: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.entity.venue), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_IconText, { dark: true }, {
        icon: _withCtx(() => [
          _hoisted_5
        ]),
        text: _withCtx(() => [
          _createElementVNode("span", _hoisted_6, [
            (_ctx.entity.startDate)
              ? (_openBlock(), _createBlock(_component_EsDate, {
                  key: 0,
                  format: "slash",
                  startDate: _ctx.entity.startDate
                }, null, 8, ["startDate"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_7, "?"))
          ])
        ]),
        _: 1
      }),
      _hoisted_8,
      _createVNode(_component_IconText, { dark: true }, {
        icon: _withCtx(() => [
          _hoisted_9
        ]),
        text: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, [
            (_ctx.entity.endDate)
              ? (_openBlock(), _createBlock(_component_EsDate, {
                  key: 0,
                  format: "slash",
                  endDate: _ctx.entity.endDate
                }, null, 8, ["endDate"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "?"))
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}